import { getService } from "../../store/api";
import { ADD_MODEL__BEGIN, ADD_MODEL__RESOLVE } from "./types";

const importModel = (data, name) => async (dispatch, getState) => {
    dispatch({ type: ADD_MODEL__BEGIN, model: data });

    const service = getService(getState());
    let errors = {};
    let model = null;
    try {
        let uri = 'v1/model/import';
        if (name) {
            uri += `?name=${encodeURIComponent(name)}`;
        }
        const response = await service.fetchEndpoint(uri, 'POST', data, true);
        model = await response.json();
    } catch (response) {
        errors = await service.getErrors(response, 'model');
    }

    dispatch({ type: ADD_MODEL__RESOLVE, model, errors });
    return { model, errors };
};

export default importModel;
